import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useObservationActionCommented } from "./observation-action-commented.hook";

const ObservationActionCommented = () => {
  const { runAction } = useObservationActionCommented();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.OBSERVATION_COMMENTED,
    runAction
  );

  return <></>;
};

export default ObservationActionCommented;
